import React, { useReducer } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@material-ui/core";
// import cellDetailContractsHistory from "./cellDetailContractsHistory";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import "./configuration-contracts-history-panel.pure.css";
import DetailsTypeContract from "./detailTypeContract";

// const SignRequestCellHeader = (props) => {
//   const cellHeaderStyles = {
//     color: "#123513",
//     fontSize: "14px",
//     display: "flex",
//     textAlign: "end",
//     fontFamily: "Quicksand",
//   };
//   return <span style={cellHeaderStyles}>{props.title}</span>;
// };

/*   const SignRequestCellStatus = (props) => {
    const stateContract = props.dataItem.contractStatus.name;
    let colorItem = "";
    let fontFamily = "";
    if (stateContract) {
      if (stateContract === "Aprobado") {
        colorItem = "#50690e";
        fontFamily = "Quicksand";
      } else if (stateContract === "Pendiente") {
        colorItem = "#005DA1";
        fontFamily = "Quicksand";
      } else if (stateContract === "Rechazado") {
        colorItem = "#E73C32";
        fontFamily = "Quicksand";
      } else if (stateContract === "Cancelado") {
        colorItem = "#FF922C";
        fontFamily = "Quicksand";
      } else {
        colorItem = "#2C353C";
        fontFamily = "Quicksand";
      }
    }
  
    return (
      <td style={{ color: `${colorItem}`, fontFamily: `${fontFamily}` }}>
        {stateContract}
      </td>
    );
  }; */

const formatNumberWithCommas = (number) => {
  if (number != null) {
    return number.toLocaleString();
  }
  return number;
};

const resolveField = (dataItem, fieldPath) => {
  // Verifica si fieldPath es realmente una cadena
  if (typeof fieldPath !== 'string') {
    console.error('El campo debe ser una cadena. Recibido:', fieldPath);
    return undefined; // O puedes devolver un valor por defecto
  }

  // Divide la ruta por el punto (.)
  const fields = fieldPath.split('.');

  // Accede al objeto de forma dinámica
  return fields.reduce((obj, field) => (obj ? obj[field] : undefined), dataItem);
};

const SignRequestCell = (props) => {
  const cellItemStyles = {
    color: "#123513",
    fontSize: "15px",
    fontFamily: "Quicksand",
  };

  const formattedValue = formatNumberWithCommas(resolveField(props.dataItem, props.field));

  return <td style={cellItemStyles}>{formattedValue}</td>;
};

const ConfigurationContractsHistoryPanelPure = (props) => {

  const { t } = useTranslation();
  const [, forceUpdate] = useReducer((x) => x + 1, 0);

  const isSmallScreen = useMediaQuery("(max-width: 768px)");

  const gridSignatureRequestPanelStyle = {
    left: "-5px",
  };

  const expandChange = (event) => {
    event.dataItem.expanded = !event.dataItem.expanded;
    forceUpdate();
  };

  return (
    <div>
      <Grid
        className="configurationContractsHistoryPanelPure-historic-plans"
        style={gridSignatureRequestPanelStyle}
        data={props.contracts.slice(props.skip, props.take + props.skip)}
        resizable
        reorderable
        skip={props.skip}
        take={props.take}
        pageable={props.showPagination}
        total={props.contracts.length}
        onPageChange={props.onPageChange}
        detail={DetailsTypeContract}
        expandField="expanded"
        onExpandChange={expandChange}
      >
        <GridColumn
          title={t('configurationSignatureHistoryPanel.client')}
          field="client.organization"
          headerClassName="align-left-header"
          className={`${isSmallScreen ? "vertical-on-small" : ""} align-left`}
        />
        {
          !isSmallScreen && (
            <GridColumn
              field="totalTransaction"
              title={t("configurationSignatureHistoryPanel.credits")}
              cell={(props) => <SignRequestCell {...props} field="totalTransaction" />}
            />
          )
        }
        {
          !isSmallScreen && (
            <GridColumn
              field="creditLogTotals.signRequest"
              title={t("configurationSignatureHistoryPanel.signatures")}
              cell={(props) => <SignRequestCell {...props} field="creditLogTotals.signRequest" />}
            />
          )
        }
        {
          !isSmallScreen && (
            <GridColumn
              field="creditLogTotals.govoAuth"
              title={t("configurationSignatureHistoryPanel.govoAuth")}
              cell={(props) => <SignRequestCell {...props} field="creditLogTotals.govoAuth" />}
            />
          )
        }
        {
          !isSmallScreen && (
            <GridColumn
              field="creditLogTotals.apiCall"
              title={t("configurationSignatureHistoryPanel.apiCall")}
              cell={(props) => <SignRequestCell {...props} field="creditLogTotals.apiCall" />}
            />
          )
        }
        {
          !isSmallScreen && (
            <GridColumn
              field="creditLogTotals.ocr"
              title={t("configurationSignatureHistoryPanel.ocr")}
              cell={(props) => <SignRequestCell {...props} field="creditLogTotals.ocr" />}
            />
          )
        }
        {
          !isSmallScreen && (
            <GridColumn
              field="creditLogTotals.ia"
              title={t("configurationSignatureHistoryPanel.ia")}
              cell={(props) => <SignRequestCell {...props} field="creditLogTotals.ia" />}
            />
          )
        }

        <GridColumn
          field="saldo"
          title={t("configurationSignatureHistoryPanel.balance")}
          cell={(props) => <SignRequestCell {...props} field="saldo" />}
          className={isSmallScreen ? "vertical-on-small" : ""}

        />

        {/* {!isSmallScreen && (
          <GridColumn
            field="actions"
            title={"Acciones"}
            cell={cellDetailContractsHistory(
              props.buttonClass,
              t("configurationSignatureHistoryView.btnRequestInvoice"),
              t("configurationSignatureHistoryView.buttonDetail"),
              props.view
            )}
          />
        )} */}

        <GridNoRecords>
          <span style={{ color: "#2C353C", fontSize: "16px", fontWeight: 600, fontFamily: "Quicksand", display: 'flex', justifyContent: 'center' }}>
            {t("signatureRequestPanelPure2.notResults")}
          </span>
        </GridNoRecords>
      </Grid>
    </div>
  );
};

export { ConfigurationContractsHistoryPanelPure as default };
